import { pageView } from "@magalu/ecomm-components/rave/events/GA/pageView";

import { pageViewCards } from "./events/GA4/pageViewCards";
import { selectItem } from "./events/GA4/selectItem";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const events = (): any => {
  return {
    "accountlist:click": [selectItem],
    pageView: [pageView],
    "paymentmethods:click": [selectItem],
    "paymentmethods:view": [pageViewCards],
    "qdccard:click": [selectItem],
  };
};

export default events;
